import styled, { css, keyframes } from 'styled-components';
import { isDark, Colors } from '../../utils/style/colors';

// Spinner rotation for the "forwarding" ring.
const spin = keyframes`
	to { transform: rotate(360deg); }
`;

// Ring sized to the avatar (40px, or 30px when `small`) and anchored to its
// top-left, so the avatar's own margin can't stretch it into an ellipse.
const ringBox = (props) => {
	const size = props.small ? 30 : 40;
	return `
		content: '';
		position: absolute;
		top: -2px;
		left: -2px;
		width: ${size + 4}px;
		height: ${size + 4}px;
		border-radius: 50%;
		box-sizing: border-box;
		pointer-events: none;
	`;
};

export const Wrapper = styled.div`
	${props => (props.ringColor || props.ringSpinning) && css`
		position: relative;
	`}
	> div {
		${props => props.small && `
			width: 30px;
    		height: 30px;
		`};
		transition: all .3s;
		${props => props.color && `
			background-color: ${props.color};
			${isDark(props.color) && `
				> * { filter: brightness(100); }
			`}
		`};
		${props => props.border && 'transform: scale(.7);'};
	}
	${props => props.ringSpinning ? css`
		&::after {
			${ringBox(props)}
			border: 3px solid transparent;
			border-top-color: ${props.ringColor || Colors.orange};
			animation: ${spin} 0.8s linear infinite;
		}
	` : props.ringColor && css`
		&::after {
			${ringBox(props)}
			border: 3px solid ${props.ringColor};
		}
	`}
`;
